'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'staff', 'StaffService', 'ModalService', '$security',
    function ($scope, $modalInstance, staff, StaffService, ModalService, $security) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.editing = editing;
        $scope.isShowEdit = isShowEdit;

        // инициализация
        init();

        // region Function

        function init() {
            $scope.edit = false;
            // копирование
            $scope.staff = angular.copy(staff);

            // Определение заголовка модального окна
            if (staff == null || staff.id == null) {
                $scope.title = "Создание нового сотрудника";
                $scope.edit = true;
            } else {
                $scope.title = 'Редактирование сотрудника "' + staff.fullName + '"';
                $scope.edit = false;
            }
        }

        /**
         * Success
         */
        function ok() {
            StaffService.api.exists({
                filters: (($scope) => {
                    let filters = [];
                    filters.push("'surname' EQ '" + $scope.staff.surname + "'");
                    filters.push("'org.id' EQ '" + $scope.staff.org.id + "'");
                    if ($scope.staff.firstName) {
                        filters.push("'firstName' EQ '" + $scope.staff.firstName + "'");
                    }
                    if ($scope.staff.middleName) {
                        filters.push("'middleName' EQ '" + $scope.staff.middleName + "'");
                    }
                    if ($scope.staff.id) {
                        filters.push("'id' NE '" + $scope.staff.id + "'");
                    }
                    return filters;
                })($scope)
            }, (data) => {
                if (data._embedded) {
                    ModalService.warning({
                        message: 'Сотрудник с такими фамилией, именем и отчеством уже есть. Продолжить все равно?',
                        apply: 'Да',
                        cancel: 'Нет'
                    }).result.then(function () {
                        $modalInstance.close($scope.staff);
                    });
                }
                else {
                    $modalInstance.close($scope.staff);
                }
            });
        }

        /**
         * Dismiss
         */
        function cancel() {
            $modalInstance.dismiss();
        }

        /**
         * Редактировать
         */
        function editing() {
            $scope.edit = true;
        }

        /**
         * Отображать кнопку редактировать?
         * @returns {boolean|*}
         */
        function isShowEdit() {
            return !$scope.edit && $security.isAllowWrite('/staffs');
        }

        // endregion

    }];